import { fCurrency } from '@/utils/formatNumber';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../card';

type CardChartTotalProps = {
  title: string;
  description: string;
  total?: string | number;
  children: React.ReactNode;
  totalLabel?: string;
};

const CardChartTotal = (props: CardChartTotalProps) => {
  const { title, description, total, children, totalLabel = 'Total' } = props;
  return (
    <>
      <Card>
        <CardHeader className="flex flex-col items-stretch space-y-0 border-b p-0 sm:flex-row">
          <div className="flex flex-1 flex-col justify-center gap-1 px-6 py-5 sm:py-6">
            <CardTitle>{title}</CardTitle>
            <CardDescription>{description}</CardDescription>
          </div>
          {total !== undefined && <div className="flex">
            <div className="relative z-30 flex flex-1 flex-col justify-center gap-1 border-t px-6 py-4 text-left even:border-l sm:border-l sm:border-t-0 sm:px-6 sm:py-4">
              <span className="text-xs text-muted-foreground">
                {totalLabel}
              </span>
              <span className="text-lg font-bold leading-none sm:text-xl">
                {total}
              </span>
            </div>
          </div>}
        </CardHeader>
        <CardContent className="px-2 sm:p-6 sm:pl-0">{children}</CardContent>
      </Card>
    </>
  );
};
export default CardChartTotal;
